<div class="c-text-with-label">
  <span class="c-text-with-label__label">{{ label }}:</span>
  <span class="c-text-with-label__text"><ng-content></ng-content></span>
</div>
